import React from "react";
import { Box, Container, Typography, Grid } from "@mui/material";
import classes from "./footer.module.scss";
// import { Link, } from 'react-scroll';
import logo from "assets/images/logo_footer.png";
import instagram from "assets/icons/instagram.svg";
import facebook from "assets/icons/facebook.svg";
import youtube from "assets/icons/youtube.svg";
import telegram from "assets/icons/telegram.svg";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const FooterComponent = () => {
  const { t } = useTranslation();

  const firstColumn = [
    { label: t("aboutUnion"), link: "/about" },
    { label: t("news"), link: "/news" },
    { label: t("legislation"), link: "/legislation" },
    { label: t("decrees"), link: "/decrees" },
    { label: t("votes"), link: "/vote" },
    { label: t("freqAskQues"), link: "/questions" },
    { label: t("tests"), link: "/tests" },
    { label: t("information"), link: "/info" },
    { label: t("conference"), link: "/conference" },
    { label: t("vacancy"), link: "/vacancy" },
    { label: t("projectsAboutUs"), link: "/competitions" },
    
  ];

  return (
    <Box component="footer" p={"80px 0"} className={classes.footer}>
      <Container>
        <Box>
          <Link to="/">
            <img style={{width:"200px"}} alt="logo" src={logo}></img>
          </Link>
        </Box>
        <Grid container className={classes.columns}>
          <Grid
            flexDirection={"column"}
            display={"flex"}
            top={"10px"}
            className={classes.firstColumn}
          >
            {firstColumn.map((column, idx) => (
              <Link
                to={column.link}
                className={classes.label}
                key={column.label}
              >
                {column.label}
              </Link>
            ))}
          </Grid>
          <Grid color={"#fff"} className={classes.secondColumn}>
            <Typography variant="h6">{t("contacts")}</Typography>
            <Typography
              sx={{
                flexDirection: "column",
                display: "flex",
                marginTop: "12px",
                gap: "10px",
              }}
            >
              <a className={classes.label} href="tel:312626151">
                +996 312 62-61-51
              </a>
              <a className={classes.label} href="tel:312626150">
                +996 312 62-61-50
              </a>
              <a className={classes.label} href="tel:312620883">
                +996 312 62-08-83
              </a>
            </Typography>
            <Typography style={{ marginTop: "10px" }}>
              msu.kg@mail.ru
            </Typography>
            <Box className={classes.icons}>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://instagram.com/soyuzmsukr"
              >
                <img className={classes.icon} src={instagram} alt="instagram" />
              </a>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.facebook.com/MSU45331/"
              >
                <img className={classes.icon} src={facebook} alt="facebook" />
              </a>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.youtube.com/channel/UCmaSfjJ-zgfHaZALjTx5mCQ/featured"
              >
                <img className={classes.icon} src={youtube} alt="youtube" />
              </a>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://t.me/msu_union_info"
              >
                <img className={classes.icon} src={telegram} alt="telegram" />
              </a>
            </Box>
          </Grid>
          <Grid className={classes.thirdColumn}>
            <Typography variant="h6">{t("address")}</Typography>
            <Typography sx={{ marginTop: "8px", lineHeight: "30px" }}>
              {t("infoFooter")}
            </Typography>
            <Typography style={{ marginTop: "10px" }}>
              Пн-Пт: 09:00-18:00
            </Typography>
          </Grid>
          <Grid className={classes.box}>
            <Box
              w="100%"
              h="100%"
              position="relative"
              overflow="hidden"
            >
              <div className={classes.map}>
                <iframe
                  src="/map.html"
                  frameBorder="0"
                  scrolling="no"
                  title="Map on 2GIS"
                ></iframe>
              </div>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default FooterComponent;
